<template>
  <div class="f14-l19 h-100 d-flex" :class="alignment" @click.stop="showPopup">
    <div class="align-items-center d-flex flex-row position-relative small-space">
      <img :src="this.cook_and_me.icon" style="height: 14px;" class="spacer-left-small pointer" @click.stop="showPopup" />
      <div class="accordion-header pointer" @click.stop="showPopup">{{this.cook_and_me.popup_data.title}}</div>
      <CaretComponent :open="show_popup" @click.stop="showPopup" />
      <div v-show="show_popup">
        <CookAndMePopupComponent :popup_data="this.cook_and_me.popup_data" />
      </div>
    </div>
    <BGClickCatcherComponent v-show="show_popup" @click.stop.prevent="showPopup" />
  </div>
</template>
<script>
  import BGClickCatcherComponent from "@/components/popup/BGClickCatcherComponent";
  import CookAndMePopupComponent from "@/components/generic/CookAndMePopupComponent.vue";
  import CaretComponent from "@/components/CaretComponent.vue";
  import {addGoogleAnalyticsDataLayer} from '@/modules/configuration.js';
  export default {
    components: {
      CookAndMePopupComponent,
      BGClickCatcherComponent,
      CaretComponent
    },
    props: {
      cook_and_me: Object,
    },
    data() {
      return {
        show_popup: false
      }
    },
    computed: {
      alignment() {
        if (this.$isDesktop()) {
          return "justify-content-center align-items-center";
        }
        return "align-items-right";
      }
    },
    methods: {
      async showPopup() {
        this.show_popup = !this.show_popup;
        if (this.show_popup) {
          await this.$nextTick();
          addGoogleAnalyticsDataLayer(this.cook_and_me.data_layer);
        }
      },
    }
  }
</script>